import { useChamberViewerTour } from './chamberViewerTourContext';
import { createTourPopover } from './createTourPopover';

const ChamberViewerTourPopover = createTourPopover(useChamberViewerTour);

export default ChamberViewerTourPopover;
